import { INHABITANT_ENTITY } from '../constants/entity'
import { getApi, postApi, putApi } from '../utils/api'

export function updateInhabitantsTableConfig(data) {
  return putApi({
    data,
    endpoint: `idwell-api/api/v3/table/tables/${INHABITANT_ENTITY.plural}/config/`,
  })
}

export function getInhabitantsStatistic() {
  return getApi({ endpoint: 'idwell-api/api/v3/inhabitancy/statistic/' })
}

export function getInhabitancyEmailRecipients(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/inhabitancy/email-recipients/',
  })
}

export function startInhabitantsExport(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/inhabitancy/inhabitants/export/',
  })
}

export function checkInhabitantsExportTask(id) {
  return getApi({ endpoint: `api/profile/export/task/${id}/` })
}

export function loadInhabitantsExportFieldsList() {
  return getApi({ endpoint: 'api/profile/export/fields-list/' })
}
